import { useToast } from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';
import { getOpportunityConsensusException } from 'services/api/requests/demand/opportunity/opportunity';

import { ISelectedFilterBody } from '../../../../components/filter/models/TableFilterModels';
import { PAGINATION_SIZE_LIST } from '../../../../utils/consts/pagination';
import {
	fetchDataByFilters,
	fetchDataByFiltersAiPrediction,
} from '../../../api/requests/checktable';

export type QueryTypeModule =
	| 'venda'
	| 'oportunidade'
	| 'consensus'
	| 'collaboration'
	| 'restricted-plan'
	| 'carteiraPedido'
	| 'ticketMedio'
	| 'ticketMedioFamilia'
	| 'estoque'
	| 'forecastDemanda'
	| 'orcamento'
	| 'produto'
	| 'hierarquiaComercial'
	| 'membro'
	| 'zonaVenda'
	| 'clienteRelacionado'
	| 'recurso'
	| 'tipologiaParadas'
	| 'ciclo'
	| 'bots'
	| 'aiPrediction'
	| 'family'
	| 'subfamily'
	| 'model-product';
interface IPaginationData {
	module: QueryTypeModule;
	page?: number;
	size?: number;
	filters?: ISelectedFilterBody[] | any[];
	cycleId?: number;
	preFilteredRows?: any;
}

export interface IRequestCheckTableBody {
	pagination: {
		page: number | undefined;
		size: number;
		order: string[][];
	};
	filters: any[] | ISelectedFilterBody[] | undefined;
	ciclo_id: number | undefined;
}

export const useGetCheckTableDataWithFilters = <T extends unknown>({
	module,
	page,
	size,
	filters,
	preFilteredRows,
	cycleId,
}: IPaginationData) => {
	const toast = useToast();

	return useQuery(
		[`${module}-list`, page, size, filters],
		() => {
			const requestBody: IRequestCheckTableBody = {
				pagination: {
					page,
					size: size || PAGINATION_SIZE_LIST[0],
					order: [],
				},
				filters: filters,
				ciclo_id: cycleId,
			};

			if (!preFilteredRows) {
				switch (module) {
					case 'aiPrediction':
						return fetchDataByFiltersAiPrediction({
							page: page !== undefined ? page + 1 : 1,
							page_size: size || PAGINATION_SIZE_LIST[0],
						});
					default:
						return fetchDataByFilters<T>(module, requestBody);
				}
			} else {
				const mapPreFilteredExcpetion = {
					oportunidade: getOpportunityConsensusException,
				};

				const updatedRequestBody = {
					...requestBody,
					preFilteredRows,
				};

				return mapPreFilteredExcpetion[module](updatedRequestBody);
			}
		},

		{
			onError: e => {
				toast({
					title: 'Erro ao buscar dados!',
					description:
						'Ocorreu um erro ao buscar os dados para listagem.',
					status: 'error',
					duration: 8000,
					position: 'bottom-left',
					isClosable: true,
				});
			},
			refetchOnWindowFocus: false,
			retry: false,
			enabled: !!module,
		}
	);
};
